import "./../style/Project.scss";

function Project({ project, onSelect }) {
  const style = {
    gridColumn: `${project.gridPosition.colStart} / ${project.gridPosition.colEnd}`,
    gridRow: `${project.gridPosition.rowStart} / ${project.gridPosition.rowEnd}`,
    background: `linear-gradient(0deg, ${project.colors[1]}, ${project.colors[0]})`,
  };

  return (
    <div className="projectPreview" style={style} onClick={() => onSelect(project.slug)}>
      <h2 className="projectTitle">{project.title}</h2>
    </div>
  );
}

export default Project;
